// export default function Pagination({ currentPage, totalPages, onPageChange }) {
//   return (
//     <div className="flex items-center  gap-2.5 mt-6">
//       <button
//         onClick={() => onPageChange(currentPage - 1)}
//         disabled={currentPage === 1}
//         className={`px-4 py-1 rounded-[10px] border text-sm font-medium transition-all
//           ${
//             currentPage === 1
//               ? "border-gray-200 bg-gray-50 text-white cursor-not-allowed opacity-50"
//               : "border-gray-200 bg-gray-50 text-black hover:bg-gray-50 hover:border-gray-300"
//           }`}
//       >
//         Prev
//       </button>

//       <span className="text-sm px-1">
//         <span className="font-medium text-gray-800">{currentPage}</span>
//         <span className="text-gray-400"> of </span>
//         <span className="font-medium text-gray-800">{totalPages}</span>
//       </span>

//       <button
//         onClick={() => onPageChange(currentPage + 1)}
//         disabled={currentPage === totalPages}
//         className={`px-4 py-1 rounded-[10px] border text-sm font-medium transition-all
//           ${
//             currentPage === totalPages
//               ? "border-gray-200 bg-gray-500 text-white cursor-not-allowed opacity-50"
//               : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-300"
//           }`}
//       >
//         Next
//       </button>
//     </div>
//   );
// }

import "./Pagination.css";

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  return (
    <div className="pagination">
      <button
        type="button"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
      >
        Prev
      </button>

      <span className="pagination-text">
        <span className="active-page">{currentPage}</span>
        <span className="of-text"> of </span>
        <span className="total-page">{totalPages}</span>
      </span>

      <button
        type="button"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`pagination-btn ${
          currentPage === totalPages ? "disabled" : ""
        }`}
      >
        Next
      </button>
    </div>
  );
}
